import { Link } from "react-router-dom";
import { ARTIST_PORTRAIT } from "./HomeHero";
import { BACKEND_URL } from "../../lib/api";

const resolveImg = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

export const FeaturedArtistsSection = ({ artists }) => (
  <section data-testid="featured-artists-section" className="px-6 md:px-12 lg:px-24 py-20">
    <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
      <div>
        <p className="label-eyebrow text-[#1E3A8A]">— Featured Artists</p>
        <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-2 text-[#111]">
          Masters in residence
        </h2>
        <p className="text-[#555] mt-2 max-w-xl">
          A rotating selection of talented African creatives and their original work.
        </p>
      </div>
      <Link
        to="/artists"
        className="label-eyebrow border border-[#1E3A8A] text-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white transition-colors px-5 py-3"
      >
        All artists →
      </Link>
    </div>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {artists.map((artist) => {
        const meta = artist.master_meta || {};
        const heroImg = resolveImg(meta.spotlight_url) || resolveImg(artist.avatar_url) || ARTIST_PORTRAIT;
        const summary = meta.blurb || artist.bio || "";
        return (
          <Link
            to={`/artist/${artist.id}`}
            key={artist.id}
            data-testid={`artist-card-${artist.id}`}
            className="group block border border-[#E5E0D8] hover:border-[#1E3A8A] bg-white transition-colors"
          >
            <div className="hover-zoom-wrap aspect-square bg-[#F2EDE5]">
              <img
                src={heroImg}
                alt={`${artist.name}, contemporary African artist${artist.country ? ` from ${artist.country}` : ""}`}
                className="hover-zoom w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src = ARTIST_PORTRAIT;
                }}
              />
            </div>
            <div className="p-5">
              <p className="label-eyebrow text-[#F4C430] [text-shadow:_0_0_1px_#1E3A8A]">
                {meta.blurb || meta.spotlight_url ? "Master in residence" : "Featured artist"}
              </p>
              <h3 className="font-serif-display text-xl text-[#1E3A8A] mt-1 font-medium">{artist.name}</h3>
              <p className="text-xs text-[#555] mt-1">
                {artist.country} · {artist.artwork_count} works
              </p>
              <p
                className={`mt-3 line-clamp-2 ${
                  meta.blurb
                    ? "font-serif-display italic text-base text-[#222] leading-snug"
                    : "text-sm text-[#444]"
                }`}
              >
                {summary}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  </section>
);
